module.exports = __webpack_public_path__ + "static/media/ueno-temple.b78db4c0.jpg";